import { cn } from '@lib/utils';
import { FunctionComponent, KeyboardEvent, ReactNode } from 'react';

export type SelectionCardProps<T> = {
  icon: (isSelected: boolean) => ReactNode;
  isDisabled?: boolean;
  isSelected: boolean;
  onClick: () => void;
  onKeyUp: (event: KeyboardEvent<HTMLDivElement>) => void;
  primaryLabel: string;
  secondaryLabel: string;
  value: T;
};

export const SelectionCard: FunctionComponent<SelectionCardProps<string | number>> = (props) => {
  const { icon, isDisabled, isSelected, onClick, onKeyUp, primaryLabel, secondaryLabel } = props;

  return (
    <div
      role="button"
      onClick={isDisabled ? undefined : onClick}
      onKeyUp={isDisabled ? undefined : onKeyUp}
      className={cn('flex flex-col items-center rounded-lg p-3 w-44 h-44', {
        'cursor-pointer': !isDisabled,
        'cursor-not-allowed': isDisabled,
        'outline-2 outline-[#3D2EFFCC] outline-offset-1 bg-linear-to-b from-indigo-300 to-gray-200 shadow-lg':
          isSelected,
        'bg-gray-100 hover:bg-gray-200': !isSelected && !isDisabled,
        'bg-gray-100': !isSelected && isDisabled,
      })}
      aria-pressed={isSelected}
      aria-disabled={isDisabled}
      tabIndex={isDisabled ? -1 : 0}
    >
      <div className="flex h-14 w-14 items-center justify-center">{icon(isSelected)}</div>
      <div
        className={cn('text-center font-sora font-medium', {
          'text-blue-600': isSelected,
          'text-gray-800': !isSelected,
        })}
      >
        {primaryLabel}
      </div>
      <div className="text-center font-sora font-light text-sm text-gray-700 mt-1">{secondaryLabel}</div>
    </div>
  );
};
